import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  loading = false;

  constructor(
    private messageService: MessageService,
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  public openSnackBar(severity: 'success' | 'warn' | 'error', detailKey: string, sticky = false) {
    const messageSeverityMap = {
      success: 'COMMON.SUCCESS_TITLE',
      warn: 'COMMON.WARNING_TITLE',
      error: 'COMMON.ERROR_TITLE',
    };
    this.translate.get([messageSeverityMap[severity], detailKey]).subscribe(translations => {
      this.messageService.add({
        severity: severity,
        summary: translations[messageSeverityMap[severity]],
        detail: translations[detailKey],
        sticky: sticky,
      });
    });
  }
}
